import { css } from '@emotion/react';
import { BOLD_FONT_FAMILY } from '../constants/constants';
import { YELLOW_COLOR } from '../styles/colors';
// NOTE: This is duplicated on the server:
export const NON_POWER_PLAYER_JACKPOT_PERCENT = 25;
export const BAD_BEAT_JACKPOT_AMOUNT_BASE_CSS = css `
  font-family: ${BOLD_FONT_FAMILY};
  font-size: 120%;
  filter: drop-shadow(3px 3px 0 rgba(0, 0, 0, 0.5));
  color: ${YELLOW_COLOR};
`;
